<template>
    <div class="content content2" v-loading="loading">
        <el-row>
          
          <el-col :span="24">
          <el-form>
            <el-form-item label="自由裁量类别：">
                <el-select v-model="zycllb" placeholder="请选择" clearable size="small" @change="getFlag">
                    <el-option label="新版自由裁量"  value="0"></el-option>
                    <el-option label="旧版自由裁量"  value="1"></el-option>
                </el-select>
            </el-form-item>
          </el-form>
          </el-col>
          <el-col :span="24">
            <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">搜索</span>
                <el-form :model="form" :inline="true">
                  <el-form-item label="大类：">
                    <el-select v-model="form.dalei" placeholder="请选择" size="small">
                      <el-option
                          v-for="(dict,i) in aydlList"
                          :key="i"
                          :label="dict.dalei"
                          :value="dict.dalei"
                          ></el-option>
                  </el-select>
                  </el-form-item>
                  <el-form-item label="内容：">
                    <el-input type="text" clearable placeholder="请输入" v-model="form.nr" size="small" style="width:300px;"></el-input>
                  </el-form-item>
                  <el-form-item>
                      <el-button @click="reset" size="small">重置</el-button>
                      <el-button type="primary" @click="handleQuery" size="small">查询</el-button>
                      
                  </el-form-item>
              </el-form>
            </div>
            </el-card>
          </el-col>
          <el-col :span="24">
            <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">大类</span>
            </div>
            <div class="box-cont">
            <ul class="aydl">
              <li v-for="(item,index) in aydlList" :key="index" :class="isActive == index?'active':''">
                <p @click="getActive(index)">{{item.dalei}}</p>
              </li>
            </ul>
            </div>
            </el-card>
          </el-col>
          <el-col :span="24">
            <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">小类</span>
            </div>
            <div class="box-cont">
            <ul class="aydl">
              <li v-for="(item,index) in aydlList2" :key="index" :class="isActive2 == index?'active':''">
                <p @click="getActive2(index)">{{item.xiaolei}}</p>
              </li>
            </ul>
            </div>
            </el-card>
          </el-col>
          <el-col :span="24">
            <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">内容</span>
            </div>
            <div class="box-cont">
              <!-- <el-table v-loading="loading" ref="multipleTable" :data="jianyiList">
                  <el-table-column align="center" label="违法程度" prop="gzsno2" width="120px" />
                  <el-table-column align="center" label="情节后果" class-name="small-padding fixed-width" width="120" >
                      <template slot-scope="scope">
                        <el-radio v-model="radio" :label="scope.$index" @change.native="getCurrentRow(scope.$index)">&nbsp;</el-radio>
                      </template>
                  </el-table-column>
              </el-table> -->
              <!-- <table id="tab" border="1" style="width: 100%; border-color:#ccc;border-collapse: collapse;" >
                <thead>
                <tr>
                    <th style="width:78px;">违法程度</th>
                    <th rowspan="2">情节后果</th>
                    <th style="width:300px;">裁量幅度</th>
                    <th style="width:76px;">选择</th>
                </tr>
                </thead>
            </table> -->
              <ul class="jynr">
                <li class="li1"><p class="width01">违法程度</p><p class="width02">情节后果</p><p class="width03">裁量幅度</p><p class="width04">选择</p></li>
                <li v-for="(item,index) in jianyiList" :key="index">
                  <div class="div1">&nbsp;{{item.cfyj}}</div>
                  <div class="div2">&nbsp;{{item.hm}}、{{item.wfxw}}</div>
                  <ul class="detail">
                    <li v-for="(itema,i) in item.detail" :key="i">
                      <p class="width01">{{itema.wfcd}}</p>
                      <p class="width05">&nbsp;{{itema.wfqj1}}</p>
                      <p class="width06">{{itema.wfqj2}}</p>
                      <p class="width03">{{itema.clfd}}</p>
                      <p class="width04">
                        <el-radio v-model="itema.radio" :label="i" @change.native="getCurrentRow(index,i)">&nbsp;</el-radio>
                      </p>
                    </li>
                  </ul>
                </li>
              </ul>
              <el-input type="textarea" :rows="3" clearable placeholder="" v-model="jianyi" style="margin-bottom:20px;"></el-input>
            </div>
            </el-card>
          </el-col>
          <el-col :span="24">
            <el-button type="primary" @click="submit">确定</el-button>
            <el-button type="danger" @click="cancelTk">取消</el-button>
          </el-col>
        </el-row>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
    export default {
      components: {},
      props: ['text'],
      data() {
        return {
          zycllb:'',
          form:{
            dalei:'',
            nr:''
          },
          jianyiList:[],
          radio:'',
          jianyi:'',
          loading:false,
          isActive:0,
          isActive2:0,
          aydlList:[],
          aydlList2:[],
          flag:''
        }
      },
      watch:{
        text(){
          
        }
      },
      created() {
        if(this.text){
          this.jianyi = this.text
        }else{
          this.jianyi = ''
        }
        this.getList();
      },
      methods: {
        getCurrentRow(index,i) {
          console.log(this.jianyiList[index].detail[i].radio)
            this.jianyiList[index].detail[i].radio = 0
            console.log(index,i);
            let text = ''
            let num = Number(this.jianyiList[index].hm)
            text = '参照《浙江省卫生行政处罚自由裁量基准》'+this.aydlList[this.isActive].dalei+'"'+this.aydlList2[this.isActive2].xiaolei+'"第'+this.numberToChinese(num)+'项"'+this.jianyiList[index].cfyj+'"违法程度'+this.jianyiList[index].detail[i].wfcd+',情节后果"'+this.jianyiList[index].detail[i].wfqj1+(this.jianyiList[index].detail[i].wfqj2?','+this.jianyiList[index].detail[i].wfqj2:'')+this.jianyiList[index].detail[i].clfd+'"进行裁量,建议给予：'+this.jianyiList[index].detail[i].clfd+'的行政处罚。'
            console.log(text)
            if(this.jianyi){//
              var regex = new RegExp('参照《浙江省卫生行政处罚自由裁量基准》', 'g'); // 使用g表示整个字符串都要匹配
              var result = this.jianyi.match(regex); //match方法可在字符串内检索指定的值，或找到一个或多个正则表达式的匹配。
              var count = !result ? 0 : result.length;
              console.log(this.jianyi,count)
              this.$alert('系统检索到你选择了'+(count+1)+'个裁量标准，请注意输入合并处罚的内容（如：两者合并建议给予xxxx）。', '标题名称', {
                confirmButtonText: '确定',
                callback: action => {
                  console.log(action)
                  if(action == 'confirm'){
                    this.jianyi = this.jianyi + text
                  }else{
                    this.jianyiList[index].detail[i].radio = -1
                  }
                }
              });
              
            }else{
              this.jianyi = text
            }
            
        },
        numberToChinese (num) {
          var digits = [
            "", "一", "二", "三", "四", "五", "六", "七", "八", "九"
          ];
          var units = ["", "十", "百", "千", "万"];
          var chineseNum = "";
          var numStr = num.toString();
          var len = numStr.length;
        
          for (var i = 0; i < len; i++) {
            var digit = parseInt(numStr[i]);
            var unit = len - i - 1;
            if (digit === 0 && chineseNum[chineseNum.length - 1] === units[1]) {
              // 处理零在十位的情况，如 20、30 等
              chineseNum = chineseNum.slice(0, -1);
            }
            chineseNum += digits[digit] + units[unit];
          }
        
          return chineseNum;
        },
        renew(e){
          this.$forceUpdate()
        },
        submit(){
          this.$emit("handleBackJianyi",this.jianyi,this.leixing)
        },
        
        init(){
          this.loading=true
        },
        async getList() {
          //获取接口
          this.loading=true
          let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZycl&valDalei=${escape(this.form.dalei)}&val=${escape(this.form.nr)}&flag=${this.flag}`)
          console.log(data)
          if(data.data){
            this.aydlList = data.data.content
            this.aydlList2 = data.data.content[0].info
            this.jianyiList = data.data.content[0].info[0].wfxwLei
            this.getNumber()
            // if(this.jianyiList){
            //   this.getTable()
            // }
            this.loading=false
          }else{
            this.loading=false
          }
        },
        confirm(){
          if(this.content1!='' && this.content1!=null){
            if(this.form.content==null){
              this.form.content=''
            }
            if(this.form.content.indexOf(this.content1) >= 0){
              this.$message.error('不能重复添加')
              return;
            }
            if(this.code=='03'||this.code=='04'){
              //if(this.Is_moban==false && this.form.content!=''){
              if(this.form.content!=''){
                this.form.content += ';' + this.content1
              }else{
                this.form.content += this.content1
                // this.Is_moban=true
              }
            }else{
              this.form.content += this.content1
            }
            this.$forceUpdate()
          }else{
             this.$message.error('请选择模板内容')
          }
        },
        cancelTk(){
          this.$emit("jianyiTk",false)
        },

        getActive(index){
          this.loading = true
          if(this.isActive != index){
            this.jianyiList = []
          }
          this.isActive = index
          this.isActive2 = 0
          this.aydlList2 = this.aydlList[this.isActive].info ? this.aydlList[this.isActive].info : []
          this.jianyiList = this.aydlList[this.isActive].info[0].wfxwLei
          this.getNumber()
          this.loading = false
        },
        getActive2(index){
          this.loading = true
          this.isActive2 = index
          this.jianyiList = this.aydlList[this.isActive].info ? this.aydlList[this.isActive].info[index].wfxwLei : []
          this.getNumber()
          this.loading = false
        },
        getNumber(){
          this.jianyiList.forEach(item => {
              // 使用正则表达式提取数字
              const numbers = item.bm.match(/\d+/g);
              if (numbers) {
                console.log(numbers)
                  // 去掉数字前面的所有零
                  const cleanedNumbers = numbers.map(num => parseInt(num, 10).toString());
                  
                  console.log(cleanedNumbers);  // 输出: ["55"]
                  item.hm = cleanedNumbers[0]
              } else {
                  item.hm = 0
              }
            })
        },
        handleQuery(){
            this.pageshow = false;
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        reset(){
          this.form = {
            dalei:'',
            nr:''
          }
          this.getList()
        },
        getFlag(){
          console.log(this.zycllb)
          this.flag = this.zycllb==1?'1':''
          this.form = {
            dalei:'',
            nr:''
          }
          this.getList()
        }
      }
    }
</script>

<style scoped>
/* .content2 .el-card__header span.text{float: left;font-size: 16px;color: #333333; margin-left: 20px;padding:0 15px;
  border-left:solid 3px #0C80E8; border-bottom: none; text-align: left;} */
.content2 >>>  .el-card__body {
    padding: 10px;
}
/* .box-cont table{border:solid 1px #ccc;}
.box-cont table th{background: #4eaafd; color: #fff; line-height: 38px;} */
.jynr{ margin-bottom: 20px;}
.jynr li{width: 100%;border:solid 1px #ccc; border-bottom: none;overflow: hidden;}
.jynr li:last-child{border-bottom:solid 1px #ccc;}
.jynr .li1 p{background: #4eaafd; color: #fff; text-align: center; float: left; line-height: 38px;}
.width01{ width:76px; text-align: center;}
.width02{ width:calc(100% - 455px);}
.width03{ width:300px; text-align: center;}
.width04{ width:76px; text-align: center;}
.width05{ width:calc(100% - 584px); min-height: 38px;}
.width06{ width:128px; text-align: center; min-height: 38px;}
.jynr li .div1,.jynr li .div2{border-bottom:solid 1px #ccc;min-height: 38px; line-height: 38px;}

.jynr li .detail li{    border: none;border-bottom:solid 1px #ccc;display: flex; flex-flow: inherit;}
.jynr li .detail li:last-child{ border-bottom: none;}
.jynr li .detail li p{ line-height: 26px;}
.jynr li p{border-right:solid 1px #ccc;}
.jynr li p.width04{border-right:none;}
.aydl{ overflow: hidden;}
.aydl li{line-height: 36px; width: 20%; float: left; overflow: hidden;}
.aydl li p { cursor: pointer; text-align: center; border:1px solid #DCDFE6; margin:5px;}
.aydl li.active p,.aydl li:hover p{ color: #fff!important; background: #0089e9; border: 1px solid #0089e9;}
</style>